import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './project.css' 
const ProjectSlider = ({projects}) => {
    return (
        <div className='projects-container'>
         
             <Swiper
            modules={[Navigation,Pagination,Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            navigation
            pagination={{clickable : true}}
            autoplay = {{delay : 5000}}
            loop={true}
            >
                {projects.map((project,index) => (
                    <SwiperSlide key={index}>
                        <div className='project-card'>
                            <img src={project.image} alt={project.title} />
                            <div className='hover-info'>
                                <h5> {project.title} </h5>
                                <span className="project-infos"> {project.description} </span>
                                 <span className="project-infos"> {project.infos} </span>
                                
                                <div className='project-links'>
                                    <a href={project.code}> code :  {project.code} </a>
                                </div>
                            </div>

                        </div>

                    </SwiperSlide>
                ))}
            </Swiper>
           
        </div>
    );
};


    const projects = [
        {
            id:1,
            title:'Infiniy store',
            infos:' I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB, JQUERYS ',
            description:'a web app for e-commerce with everything, a system for administrator and client, the client can make a research, like an item, comment and buy. everything he doens, he can see it into his profil with a graphic and a history. ',
            image:'/assets/img-project/PROJET 2.jpg',
            code:'https://github.com/winalfani243/WEB-ECOMMERCE'
        },
        {
            id:2,
            title:'Infiniy store',
            infos:' I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB, JQUERYS ',
            description:"Here's the post_detail of an item, with like,comment and more",
            image:'/assets/img-project/PROJET 3.jpg',
            code:'https://github.com/winalfani243/WEB-ECOMMERCE',
        },
        {
            id:3,
            title:'Infiniy store',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB, JQUERYS ',
            description:"Here's a categorie of every item",
            image:'/assets/img-project/PROJET 4.jpg',
            code:'https://github.com/winalfani243/WEB-ECOMMERCE'
        },
         {
            id:4,
            title:'Infinity store',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB, JQUERYS',
            description:"Here's the chatbox between the client and the seller",
            image:'/assets/img-project/PROJET 5.jpg',
            code:'https://github.com/winalfani243/WEB-ECOMMERCE'
        },
         {
            id:5,
            title:'Infinity store',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB, JQUERYS',
            description:"Here's the pannel for the administrator and also for the client, with the historic of everythings ",
            image:'/assets/img-project/PROJET 6.jpg',
            code:'https://github.com/winalfani243/WEB-ECOMMERCE'
        },
         {
            id:6,
            title:'Infinity store',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB, JQUERYS',
            description:"Here's a way to pay for an order by the client ",
            image:'/assets/img-project/PROJET 7.jpg',
            code:'https://github.com/winalfani243/WEB-ECOMMERCE'
        },
         {
            id:7,
            title:'Infinity store',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB, JQUERYS',
            description:"Here's a way to login the profil of the client or the administrator ",
            image:'/assets/img-project/PROJET 8.jpg',
            code:'https://github.com/winalfani243/WEB-ECOMMERCE'
        },
         {
            id:8,
            title:'Mivex',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB,SENDGRID',
            description:"Here's a web app for an ONG, with an appointment system, newsletter, a administrator pannel  and more ...",
            image:'/assets/img-project/PROJET 9.jpg',
            code:'https://github.com/winalfani243/mivex1'
        },
        {
            id:9,
            title:'Mivex',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB,SENDGRID',
            description:"Here's a web app for an ONG, with an appointment system, newsletter, a administrator pannel  and more ...",
            image:'/assets/img-project/PROJET 11.jpg',
            code:'https://github.com/winalfani243/mivex1'
        },
        {
            id: 10,
            title:'Mivex',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB,SENDGRID',
            description:"Here's a web app for an ONG, with an appointment system, newsletter, a administrator pannel  and more ...",
            image:'/assets/img-project/PROJET 12.jpg',
            code:'https://github.com/winalfani243/mivex1'
        },

     {
            id:12,
            title:'SOCIETE MUSAMBI',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB,SENDGRID, WHATSAPP_API',
            description:"Here's a web app for a society who helps widow, orphelan and more to find refuge and foods",
            image:'/assets/img-project/TANYA PAGE 1.jpg',
            code:'https://github.com/winalfani243'
        },
         {
            id:13,
           title:'SOCIETE MUSAMBI',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB,SENDGRID, WHATSAPP_API',
            description:"Here's a web app for a society who helps widow, orphelan and more to find refuge and foods; i made a appointmentform, administrator pannel and more ...",
            image:'/assets/img-project/TANYA PAGE 2.jpg',
            code:'https://github.com/winalfani243/tanya'
        },
         {
            id:14,
            title:'SOCIETE MUSAMBI',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB,SENDGRID, WHATSAPP_API',
            description:"Here's a web app for a society who helps widow, orphelan and more to find refuge and foods; i made a appointmentform, administrator pannel and more ...",
            image:'/assets/img-project/TANYA PAGE 3.jpg',
            code:'https://github.com/winalfani243/tanya'
        },
         {
            id:15,
             title:'SOCIETE MUSAMBI',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB,SENDGRID, WHATSAPP_API',
            description:"Here's a web app for a society who helps widow, orphelan and more to find refuge and foods; i made a appointmentform, administrator pannel and more ...",
            image:'/assets/img-project/TANYA PAGE 4.jpg',
            code:'https://github.com/Winlecodwinalfani243eur/tanya'
        },
        {
            id:16,
            title:'WEDDING APP',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB',
            description:"Here's a web app for wedding, i made for someone with a system of transfering  invitation to people, QR CODE, pannel administrator, comment section and more ...",
            image:'/assets/img-project/CARINE PAGE 1.jpg',
            code:'https://github.com/winalfani243/wedding_deborah'
        },
        {
            id:17,
            title:'WEDDING APP',
            infos:'I used : HTML, CSS, JS, PYTHON, DJANGO, MONGO DB',
            description:"Here's a web app for wedding, i made for someone with a system of transfering invitation to people, QR CODE, pannel administrator, comment section and more ...",
            image:'/assets/img-project/CARINE PAGE 2.jpg',
            code:'https://github.com/winalfani243/wedding_deborah'
        },
        {
            id:18,
            title:'MY REPOSITORIES GITHUB',
            infos:'created by roger alfani aka win alfani',
            description:"Here's all of my public github repositories, my private repositories are only for my client and me",
            image:'/assets/img-project/OIP (4).jpeg',
            code:'https://github.com/winalfani243'
        },
    ]

const PortfolioProject = () => {
    return (
         <section id="portfolio">
      <h2>My Projects </h2>
      <small className='small-1'> clic on the photo to get details </small>
      <small className='small-2'> Swipe over the photo for more details"

 </small>
      <ProjectSlider projects={projects} />
    </section>
    )
}
export default PortfolioProject;